import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        [theme.breakpoints.down("desktop")]: {
            marginTop: 34,
        },
    },

    editMode_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
        [theme.breakpoints.down("desktop")]: {
            marginTop: 0,
        },
    },

    paddingTopClass: {
        paddingTop: 20,
    },

    editPopup_container: {
        width: "100%",
    },

    headerContainer: {
        position: "fixed",
        right: 30,
        top: 30,
        zIndex: 100,
    },

    rtlHeader: {
        right: "auto",
        left: 30,
    },

    content: {
        width: "100%",
        maxWidth: 1100,
        paddingLeft: 10,
        paddingRight: 60,
        [theme.breakpoints.down("desktop")]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },

    noScroll: {
        overflow: "hidden",
        height: 200,
    },

    headerWithEdit: {
        top: 80,
    },

    headerWithNoEdit: {
        top: 20,
    },
}));

export default useStyles;
